/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type BadgeChatActivityUnassigned_EmbedViewer = {
    readonly countUnassigned: number | null;
    readonly " $refType": "BadgeChatActivityUnassigned_EmbedViewer";
};
export type BadgeChatActivityUnassigned_EmbedViewer$data = BadgeChatActivityUnassigned_EmbedViewer;
export type BadgeChatActivityUnassigned_EmbedViewer$key = {
    readonly " $data"?: BadgeChatActivityUnassigned_EmbedViewer$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"BadgeChatActivityUnassigned_EmbedViewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BadgeChatActivityUnassigned_EmbedViewer",
  "selections": [
    {
      "alias": "countUnassigned",
      "args": null,
      "kind": "ScalarField",
      "name": "chatActivityUnassignedCount",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = '4cdac268cb0cb5e844f40db4916f7023';
export default node;
